//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {mergeMap as _observableMergeMap, catchError as _observableCatch} from 'rxjs/operators';
import {Observable, throwError as _observableThrow, of as _observableOf} from 'rxjs';
import {Injectable, Inject, Optional} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse, HttpResponseBase} from '@angular/common/http';
import {BOKKZ_BASE_URL, FileResponse, SwaggerException} from '@snelstart-ventures/fiscaal/domain-logic';

@Injectable({
  providedIn: 'root'
})
export class BokkzMumaClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BOKKZ_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @return default response
   */
  getAllMuma(clientId: string): Observable<MumaEntity[]> {
    let url_ = this.baseUrl + "/api/v1/sst/muma/{clientId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetAllMuma(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetAllMuma(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<MumaEntity[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<MumaEntity[]>;
    }));
  }

  protected processGetAllMuma(response: HttpResponseBase): Observable<MumaEntity[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MumaEntity[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getOneMuma(clientId: string, mumaId: string): Observable<MumaEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/muma/{clientId}/{mumaId}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    if (mumaId === undefined || mumaId === null)
      throw new Error("The parameter 'mumaId' must be defined.");
    url_ = url_.replace("{mumaId}", encodeURIComponent("" + mumaId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetOneMuma(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetOneMuma(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<MumaEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<MumaEntity>;
    }));
  }

  protected processGetOneMuma(response: HttpResponseBase): Observable<MumaEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MumaEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getMumaOverzicht(): Observable<MumaOverzicht[]> {
    let url_ = this.baseUrl + "/api/v1/sst/muma";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetMumaOverzicht(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetMumaOverzicht(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<MumaOverzicht[]>;
        }
      } else
        return _observableThrow(response_) as any as Observable<MumaOverzicht[]>;
    }));
  }

  protected processGetMumaOverzicht(response: HttpResponseBase): Observable<MumaOverzicht[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MumaOverzicht[];
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getSwagger(): Observable<void> {
    let url_ = this.baseUrl + "/api/v1/sst/openapi";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetSwagger(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetSwagger(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processGetSwagger(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    }
  }

  /**
   * @param body (optional)
   * @return default response
   */
  postOneMuma(clientId: string, sendToAuthorities: boolean, body?: MumaEntity | undefined): Observable<MumaEntity> {
    let url_ = this.baseUrl + "/api/v1/sst/muma/{clientId}/{sendToAuthorities}";
    if (clientId === undefined || clientId === null)
      throw new Error("The parameter 'clientId' must be defined.");
    url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
    if (sendToAuthorities === undefined || sendToAuthorities === null)
      throw new Error("The parameter 'sendToAuthorities' must be defined.");
    url_ = url_.replace("{sendToAuthorities}", encodeURIComponent("" + sendToAuthorities));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processPostOneMuma(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processPostOneMuma(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<MumaEntity>;
        }
      } else
        return _observableThrow(response_) as any as Observable<MumaEntity>;
    }));
  }

  protected processPostOneMuma(response: HttpResponseBase): Observable<MumaEntity> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let resultdefault: any = null;
        resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MumaEntity;
        return _observableOf(resultdefault);
      }));
    }
  }

  /**
   * @return default response
   */
  getExternalGrammar(path: string): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl/{path}";
    if (path === undefined || path === null)
      throw new Error("The parameter 'path' must be defined.");
    url_ = url_.replace("{path}", encodeURIComponent("" + path));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetExternalGrammar(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetExternalGrammar(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetExternalGrammar(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }

  /**
   * @return default response
   */
  getWadl(): Observable<FileResponse> {
    let url_ = this.baseUrl + "/application.wadl";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Accept": "application/json"
      })
    };

    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetWadl(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetWadl(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<FileResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<FileResponse>;
    }));
  }

  protected processGetWadl(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({fileName: fileName, data: responseBlob as any, status: status, headers: _headers});
    }
  }
}

export interface MumaEntity {
  id?: number;
  taxPayerFiscalNumber: string;
  year?: number;
  type?: string;
  mumaRequest?: MumaRequest;
  machtigingStatus?: MumaEntityMachtigingStatus;
  machtigingStatusToelichting?: string;
  submissionDate?: Date;
  lastCheckDate?: Date;

  [key: string]: any;
}

export interface MumaRequest {
  bsn: string;
  dienst: MumaRequestDienst;
  activatieToken: string;
  aanleverkenmerk: string;
  mutatieType: MumaRequestMutatieType;
  gemachtigdeIdentiteitsNummer: string;

  [key: string]: any;
}

export interface MumaOverzicht {
  clientName: string;
  sstRelationId: string;
  statusDoorlopendeMachtiging?: MumaEntityMachtigingStatus;
  statusDoorlopendeMachtigingTsg?: MumaEntityMachtigingStatus;
  statusDoorlopendeMachtigingOb?: MumaEntityMachtigingStatus;
  statusMachtigingHuidigJaar?: MumaEntityMachtigingStatus;
  statusMachtigingHuidigJaarTsg?: MumaEntityMachtigingStatus;
  statusMachtigingHuidigJaarOb?: MumaEntityMachtigingStatus;
  statusMachtigingHuidigJaarVia?: MumaEntityMachtigingStatus;
  statusMachtigingVorigJaar?: MumaEntityMachtigingStatus;
  statusMachtigingVorigJaarTsg?: MumaEntityMachtigingStatus;
  statusMachtigingVorigJaarOb?: MumaEntityMachtigingStatus;
  statusMachtigingVorigJaarVia?: MumaEntityMachtigingStatus;

  [key: string]: any;
}

export enum MumaEntityMachtigingStatus {
  ONTVANGEN = "ONTVANGEN",
  IN_BEHANDELING = "IN_BEHANDELING",
  AFGEKEURD = "AFGEKEURD",
  ACTIEF = "ACTIEF",
  NIET_ACTIEF = "NIET_ACTIEF",
  CONTROLEREN = "CONTROLEREN",
  UNKNOWN = "UNKNOWN",
  __ = "__",
}

export enum MumaRequestDienst {
  SBA_IH_2019 = "SBA_IH_2019",
  SBA_IH_2020 = "SBA_IH_2020",
  SBA_IH_2021 = "SBA_IH_2021",
  SBA_IH_2022 = "SBA_IH_2022",
  SBA_IH_2023 = "SBA_IH_2023",
  SBA_IH_2024 = "SBA_IH_2024",
  SBA_IH_2025 = "SBA_IH_2025",
  SBA_IH_2026 = "SBA_IH_2026",
  VIA_2020 = "VIA_2020",
  VIA_2021 = "VIA_2021",
  VIA_2022 = "VIA_2022",
  VIA_2023 = "VIA_2023",
  VIA_2024 = "VIA_2024",
  VIA_2025 = "VIA_2025",
  VIA_2026 = "VIA_2026",
  SBA_OB_2020 = "SBA_OB_2020",
  SBA_OB_2021 = "SBA_OB_2021",
  SBA_OB_2022 = "SBA_OB_2022",
  SBA_OB_2023 = "SBA_OB_2023",
  SBA_OB_2024 = "SBA_OB_2024",
  SBA_OB_2025 = "SBA_OB_2025",
  SBA_OB_2026 = "SBA_OB_2026",
  SBA_VpB_2019 = "SBA_VpB_2019",
  SBA_VpB_2020 = "SBA_VpB_2020",
  SBA_VpB_2021 = "SBA_VpB_2021",
  SBA_VpB_2022 = "SBA_VpB_2022",
  SBA_VpB_2023 = "SBA_VpB_2023",
  SBA_VpB_2024 = "SBA_VpB_2024",
  SBA_VpB_2025 = "SBA_VpB_2025",
  SBA_TSG_2019 = "SBA_TSG_2019",
  SBA_TSG_2020 = "SBA_TSG_2020",
  SBA_TSG_2021 = "SBA_TSG_2021",
  SBA_TSG_2022 = "SBA_TSG_2022",
  SBA_TSG_2023 = "SBA_TSG_2023",
  SBA_TSG_2024 = "SBA_TSG_2024",
  SBA_TSG_2025 = "SBA_TSG_2025",
  SBA_TSG_2026 = "SBA_TSG_2026",
  Beconuitstel_2020 = "Beconuitstel_2020",
  Beconuitstel = "Beconuitstel",
  DoMa_IH = "DoMa_IH",
  DoMa_OB = "DoMa_OB",
  DoMa_VpB = "DoMa_VpB",
  DoMa_TSG = "DoMa_TSG",
}

export enum MumaRequestMutatieType {
  Activeren = "activeren",
  Opvoeren = "opvoeren",
  Intrekken = "intrekken",
  Via_verzoek = "via_verzoek",
}


function throwException(message: string, status: number, response: string, headers: {
  [key: string]: any;
}, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
